const displayMode_Form = 'form';
const displayMode_FreeText = 'free-text';
const displayMode_Search = 'search';
const displayModes = [displayMode_Form, displayMode_FreeText, displayMode_Search];
const stepStatus_NotSubmitted = 'not-submitted';
const stepStatus_Submitting = 'submitting';
const stepStatus_Submitted = 'submitted';
const stepStatuses = [stepStatus_NotSubmitted, stepStatus_Submitting, stepStatus_Submitted];
export {};
//# sourceMappingURL=types.js.map